import React from 'react';
import { Heart, Trophy } from 'lucide-react';
import { Like } from '../types/likes';
import LikeButton from './LikeButton';

interface AchievementItemProps {
  achievement: Like;
  onClick?: () => void;
  showDetailedView?: boolean;
  isTopAchievement?: boolean;
}

const AchievementItem: React.FC<AchievementItemProps> = ({ 
  achievement, 
  onClick,
  showDetailedView = false,
  isTopAchievement = false
}) => {
  const getTypeLabel = (type: Like['type']) => {
    const labels = {
      fact: 'Useless Fact',
      animal: 'Animal Fact',
      science: 'Science Fact',
      excuse: 'Random Excuse',
      record: 'Pointless Record',
      invention: 'Useless Invention',
      number: 'Number Fact',
      challenge: 'Daily Challenge'
    };
    return labels[type];
  };

  if (showDetailedView) {
    return (
      <div 
        className="bg-black/20 backdrop-blur-sm rounded-lg p-6 mb-6 cursor-pointer hover:bg-black/30 transition duration-300 transform hover:-translate-y-1 border border-white/5"
        onClick={onClick}
      >
        <div className="flex items-center justify-between mb-3">
          <span className="text-sm font-medium px-3 py-1 rounded-full bg-purple-500/20 text-purple-300">
            {getTypeLabel(achievement.type)}
          </span>
          {isTopAchievement && (
            <div className="flex items-center space-x-1 px-2 py-1 bg-yellow-500/20 text-yellow-300 rounded-full text-xs font-medium">
              <Trophy className="h-3 w-3" />
              <span>Most Liked Today</span>
            </div>
          )}
        </div>
        <p className="text-gray-200 text-lg mb-4 font-medium">{achievement.content}</p>
        <div className="flex items-center space-x-2 text-red-400">
          <Heart className="h-5 w-5 fill-current" />
          <span className="font-bold">{achievement.likes} likes</span>
        </div>
      </div>
    );
  }

  return (
    <div 
      className="flex items-center justify-between text-sm border-t border-white/5 py-4 cursor-pointer hover:bg-black/20 transition duration-200 px-4 rounded-lg"
      onClick={onClick}
    >
      <div className="flex items-center space-x-3 flex-1">
        <span className="px-2 py-1 rounded-full bg-purple-500/20 text-purple-300 text-xs font-medium">
          {getTypeLabel(achievement.type)}
        </span>
        <span className="truncate flex-1 text-gray-300">{achievement.content}</span>
      </div>
      <div className="flex items-center space-x-1 text-red-400">
        <Heart className="h-4 w-4 fill-current" />
        <span className="font-medium">{achievement.likes}</span>
      </div>
    </div>
  );
};

export default AchievementItem;